import { call, put, takeLatest } from "redux-saga/effects";
import { ITongHopKyRequest } from "../../../model/request/tong-hop-diem/ITongHopKyRequest";
import { eTongHopKyActionIds, ITongHopKyActionTypes } from "../../action-types/tong-hop-diem/ITongHopKyActions";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { tongHopKyApi } from "../../../api/tong-hop-diem/tongHopKyApi";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";


export function* tongHopKySaga(): any {
    yield takeLatest(eTongHopKyActionIds.LOAD_START, loadWorker);
}

function* loadWorker(action: ITongHopKyActionTypes ) {
    const request  = action.payload as ITongHopKyRequest;
    const response: IBaseResponse = yield call(tongHopKyApi.Select,request);
    if (response.is_success) {
      yield put(rootActions.tongHopDiem.tongHopKy.LOAD_SUCCESS(toLowerCaseDeep(response.data)))
    } else {
       yield put(rootActions.tongHopDiem.tongHopKy.LOAD_ERROR(response.message ?? "Có lỗi"))
    }
}